import * as React from "react";
import { forwardRef } from "react";
const LogoYandexSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fill: "#FC3F1D", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
    React.createElement("path", { fill: "#fff", d: "M9.172 13V4.373h-.82c-1.502 0-2.289.714-2.289 1.779 0 1.208.543 1.768 1.666 2.481l.925.593L6 13H4l2.41-3.368C5.033 8.698 4.259 7.787 4.259 6.25 4.259 4.328 5.667 3 8.338 3H11v10z" }));
const ForwardRef = forwardRef(LogoYandexSVG);
export default ForwardRef;
//# sourceMappingURL=LogoYandex.js.map